
import Vue from "vue"
import { emailReasonLocaleKey, normalizeEmail, validateEmail } from "@/utils/emailAddress"

export default Vue.extend({
    name: "EmailRulesMixin",
    methods: {
        emailReasonMessage(reason: string, address = ""): string {
            const label = this.$vuetify.lang.t(`$vuetify.${emailReasonLocaleKey(reason)}`)
            return address ? `${label} (${address})` : label
        },
        emailRule(value: string | null) {
            if (value == null || normalizeEmail(String(value)) === "") {
                return this.emailReasonMessage("required")
            }
            const address = normalizeEmail(String(value))
            const reason = validateEmail(address)
            return reason === null || this.emailReasonMessage(reason, address)
        },
        optionalEmailRule(value: string | null) {
            if (value == null || normalizeEmail(String(value)) === "") {
                return true
            }
            return this.emailRule(value)
        },
        emailsRule(values: Array<string> | null) {
            if (!values || values.length === 0) {
                return this.$vuetify.lang.t("$vuetify.at_least_one_email")
            }
            const byReason = new Map<string, string[]>()
            let fallback: string | true = true
            for (const value of values) {
                if (typeof value !== "string") {
                    fallback = this.emailReasonMessage("invalid_type")
                    continue
                }
                const address = normalizeEmail(value)
                if (address === "") {
                    fallback = this.emailReasonMessage("required")
                    continue
                }
                const reason = validateEmail(address)
                if (reason !== null) {
                    const group = byReason.get(reason) ?? []
                    group.push(address)
                    byReason.set(reason, group)
                }
            }
            if (byReason.size > 0) {
                return Array.from(byReason.entries())
                    .map(([reason, addresses]) => this.emailReasonMessage(reason, addresses.join(", ")))
                    .join("\n")
            }
            return fallback
        },
    }
})
